import React, {useState} from 'react';
import { useParams } from "react-router-dom";

import AddSystemUserForm from './component/AddSystemUserForm'
import SystemUserList from './component/SystemUserList'

import { PageTitle } from "../../../../_template/layout/core/PageData";

const SystemUser = () => {
    const { company } = useParams();
    const loginUserType = localStorage.getItem('type');

    const systemUserTitle = [
        {
            title: 'Agents',
            path: loginUserType === 'SA' ? `${company}/agents/` : '/agents',
            isSeparator: false,
            isActive: false,
        },
        {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
        },
    ];

    const [searchValue, setSearchValue] = useState('');

    const searchHandler = (event) => {
        setSearchValue(event.target.value);
    }

    const [isFormSubmited, setIsFormSubmited] = useState(false);
    const formSubmittedHandler = () => {
        setIsFormSubmited(true)
    }

    const refreshSuccessHandler = () => {
        setIsFormSubmited(false)
    }

    const [totalSystemUserCount , setTotalSystemUserCount] = useState(0);
    const totalSystemUserCountHandler = (totalSystemUser) => {
        setTotalSystemUserCount(totalSystemUser)
    }

    const [ systemUserUpdateDataState , setSystemUserUpdateDataState ] = useState({});
    const systemUserUpdateDataHandler = (updateData) => {
        setSystemUserUpdateDataState(updateData)
    }

    return (
        <>
            <PageTitle breadcrumbs={systemUserTitle}>System User</PageTitle>
            <AddSystemUserForm
                onChange={searchHandler}
                formSubmited={formSubmittedHandler}
                totalSystemUserCount={totalSystemUserCount}
                updatedData={systemUserUpdateDataState}
            />
            <SystemUserList
                searchData={searchValue}
                isFormSubmited={isFormSubmited}
                refreshSuccess={refreshSuccessHandler}
                totalSystemUserCount={totalSystemUserCountHandler}
                systemUserUpdateData={systemUserUpdateDataHandler}
            />
        </>
    )
}

export default SystemUser